import { render, staticRenderFns } from "./FolderSidebar.vue?vue&type=template&id=490d58f0&scoped=true&"
import script from "./FolderSidebar.vue?vue&type=script&lang=js&"
export * from "./FolderSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FolderSidebar.vue?vue&type=style&index=0&id=490d58f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d58f0",
  null
  
)

export default component.exports